import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * The high score for this quiz set against the attempt just submitted. Its two
 * rows line up with Correct and Incorrect in the column beside it.
 *
 * Props:
 *   id         (string) - ID prefix for generated element IDs.
 *   percentage (number) - This attempt's score, 0 to 100.
 *   highScore  (number) - Best score recorded for this quiz, or null.
 */
export const ScoreTotals = ({ id, percentage, highScore }) => (
  <Box className="scoreTotals">
    {/* A high score of 0 is still worth showing, so check for a value not truthiness. */}
    {Number.isFinite(highScore) && (
      <Typography className="scoreTotal" id={`${id}__highScore`}>
        <span className="scoreTotalLabel">High Score:</span> {highScore}%
      </Typography>
    )}

    <Typography className="scoreTotal" id={`${id}__currentScore`}>
      <span className="scoreTotalLabel">Current Score:</span> {percentage}%
    </Typography>
  </Box>
);
